import React from 'react';
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Box,
  TextField,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import TransferToCellMaterials from '../../TransferToCellMaterials';
import ItsUninstaledMaterials from '../ItsProtocols/ItsUninstaledMaterials';

import { useDispatch, useSelector } from 'react-redux';
import { addDocumentStyle, removeDocumentStyle } from '../constants';
import { getTime } from '../../../../helperFunctions';
import {
  handleStartChange,
  handleEndChange,
  handleTroubleDescriptionChange,
  handlePerformedActivitiesDescriptionChange,
  handleDamageDescriptionChange,
  handleClientNotAgreedDescriptionChange,
  toggleProtocolFields,
  toggleAggreedWithPerformedActivitiesDescriptionField,
  toggleDamageDescriptionField,
} from '../../../../helperFunctions/its/itsDescriptiveProtocolHelper';
import { useStyles } from '../../../../helperFunctions/its';

export default () => {
  const data = useSelector(state => state.tasks.data);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);

  const dispatch = useDispatch();

  if (!task) return null;

  const itsDescriptiveProtocol = task ? task.itsDescriptiveProtocol : null;

  let isProtocolOpen = itsDescriptiveProtocol && itsDescriptiveProtocol.open;
  let buttonStyle = isProtocolOpen ? removeDocumentStyle : addDocumentStyle;
  let buttonText = isProtocolOpen
    ? 'Премахни Констативен протокол за посещение'
    : 'Добави Констативен протокол за посещение';

  const classes = useStyles();

  return (
    <>
      <Button
        variant="contained"
        style={buttonStyle}
        onClick={() => toggleProtocolFields(dispatch, data, task, itsDescriptiveProtocol)}
      >
        {buttonText}
      </Button>
      {isProtocolOpen ? (
        <>
          <div style={{ margin: '3px' }}>
            <TransferToCellMaterials />
            <ItsUninstaledMaterials />
          </div>
          <FormControl
            style={{ marginTop: '10px', width: '100%' }}
            component="fieldset"
            variant="standard"
          >
            <FormGroup>
              <Box display="flex" marginTop={1} marginBottom={1}>
                <Box flex={1} marginRight="2px">
                  <TextField
                    className={classes.root}
                    variant="filled"
                    type="time"
                    label="Начало на посещение"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    value={getTime(task.itsDescriptiveProtocol.start)}
                    onChange={event => handleStartChange(event, dispatch, task, data)}
                  />
                </Box>
                <Box flex={1}>
                  <TextField
                    className={classes.root}
                    variant="filled"
                    type="time"
                    label="Край на посещение"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={getTime(task.itsDescriptiveProtocol.end)}
                    onChange={event => handleEndChange(event, dispatch, task, data)}
                  />
                </Box>
              </Box>
              <TextField
                multiline
                label="Описание на повредата"
                value={task.itsDescriptiveProtocol.troubleDescription}
                fullWidth
                variant="filled"
                onChange={event => handleTroubleDescriptionChange(event, dispatch, task, data)}
              />
              <TextField
                multiline
                label="Описание на извършените дейности"
                value={task.itsDescriptiveProtocol.performedActivitiesDescription}
                fullWidth
                variant="filled"
                onChange={event =>
                  handlePerformedActivitiesDescriptionChange(event, dispatch, task, data)
                }
              />
            </FormGroup>
            <Box marginTop={1}>
              <FormControl className={classes.damageFields}>
                <FormLabel>
                  Има ли нанесени щети върху собственост на клиента при посещението:
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={task.itsDescriptiveProtocol.damageDescriptionField ?? 'no'}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio size="small" />}
                    label="Да. Моля опишете нанесената щета"
                    onClick={() => toggleDamageDescriptionField(dispatch, task, data, true)}
                  />
                  {task.itsDescriptiveProtocol.damageDescriptionField === 'yes' ? (
                    <TextField
                      multiline
                      variant="filled"
                      label="Описание"
                      value={task.itsDescriptiveProtocol.damageDescription}
                      onChange={event => handleDamageDescriptionChange(event, dispatch, task, data)}
                    />
                  ) : (
                    <></>
                  )}
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        size="small"
                        onClick={() => toggleDamageDescriptionField(dispatch, task, data, false)}
                      />
                    }
                    label="Не"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box marginTop={1}>
              <FormControl className={classes.damageFields}>
                <FormLabel>Съгласен ли е клиента с извършените дейности:</FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={task.itsDescriptiveProtocol.agreeWithPerformedActivitiesField ?? 'yes'}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="yes"
                    control={
                      <Radio
                        size="small"
                        onClick={() =>
                          toggleAggreedWithPerformedActivitiesDescriptionField(
                            dispatch,
                            task,
                            data,
                            true
                          )
                        }
                      />
                    }
                    label="Да"
                  />
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        size="small"
                        onClick={() =>
                          toggleAggreedWithPerformedActivitiesDescriptionField(
                            dispatch,
                            task,
                            data,
                            false
                          )
                        }
                      />
                    }
                    label="Не. Моля опишете забележките:"
                  />
                  {task.itsDescriptiveProtocol.agreeWithPerformedActivitiesField === 'no' ? (
                    <TextField
                      multiline
                      variant="filled"
                      label="Описание"
                      value={task.itsDescriptiveProtocol.clientNotAgreedDescription}
                      onChange={event =>
                        handleClientNotAgreedDescriptionChange(event, dispatch, task, data)
                      }
                    />
                  ) : (
                    <></>
                  )}
                </RadioGroup>
              </FormControl>
            </Box>
          </FormControl>
        </>
      ) : null}
    </>
  );
};
